// import * as React from "react";
import React, { useContext, useEffect, useState } from "react";
import useSnackbar from "./../../../../hooks/useSnackbar";
import _ from "lodash";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { addressParse } from "@zerodep/address-parse";

import {
  Autocomplete,
  TextField,
  Snackbar,
  Alert,
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Typography,
  OutlinedInput,
  FormHelperText
} from "@mui/material";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useTheme } from "@mui/material/styles";
import AlertDialog from "../../../../components/Dialogs/AlertDialog";

import { useFormik } from "formik";
import * as Yup from "yup";

import {
  EMAIL_REGEX,
  PASSWORD_REGEX,
  SCOPE_MODES
} from "../../../../constants";

import HttpContext from "../../../../contexts/HTTP/HttpContext";

function CreateCharityDialog({
  charity,
  open,
  handleClose,
  handleSaveEditChanges
}) {
  const theme = useTheme();

  const [charities, setCharities] = useState(charity);

  // const [active, setActive] = useState(true);
  // const [locationName, setLocationName] = useState("");
  // const [locationAddress, setLocationAddress] = useState("");
  // const [locationCode, setLocationCode] = useState("");
  // const [subscriptionID, setSubscriptionID] = useState("");
  // const [defaultWorkflow, setDefaultWorkflow] = useState("");
  // const [enableWebClient, setEnableWebClient] = useState(false);

  const [charityID, setCharityID] = useState("");
  const [charityName, setCharityName] = useState("");
  const [charityLogoURL, setCharityLogoURL] = useState("");
  const [charityMission, setCharityMission] = useState("");
  const [charityAddress, setCharityAddress] = useState("");
  const [charityAddressParseObj, setCharityAddressParseObj] = useState("");
  const [charityScope, setCharityScope] = useState("");
  const [charityPin, setCharityPin] = useState("");
  const [enabled, setEnabled] = useState(true);

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { openSnackbar } = useSnackbar();

  useEffect(() => {
    if (charity) {
      setCharityID(charity.charityID);
      setCharityName(charity.name);
      setCharityLogoURL(charity.logoUrl);
      setCharityMission(charity.mission);
      setCharityAddress(charity.location.description);
      setCharityAddressParseObj(addressParse(charity.location.description));
      setCharityScope(charity.scope);
      setCharityPin(charity.pin); //TEMPORARY
      setEnabled(charity.enabled);
    }
  }, [charity]);

  const saveChanges = async () => {
    const payload = {
      id: charity?._id,
      charityID: charityID,
      name: charityName,
      logoUrl: charityLogoURL,
      mission: charityMission,
      location: { description: charityAddress },
      scope: charityScope,
      pin: charityPin, //TEMPORARY
      enabled: enabled
    };

    await handleSaveEditChanges(payload);
  };

  const revertChanges = async () => {
    if (charity) {
      setCharityID(charity.charityID);
      setCharityName(charity.name);
      setCharityLogoURL(charity.logoUrl);
      setCharityMission(charity.mission);
      setCharityAddress(charity.location.description);
      setCharityPin(charity.pin); //TEMPORARY
      setEnabled(charity.enabled);
    }

    handleClose();
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={false}
        maxWidth={false}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-kiosklist"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "30vw"
          }}
        >
          <DialogTitle
            id="modal-kiosklist"
            style={{
              maxWidth: "19vw"
            }}
          >
            {charity ? "Edit " + charity.name : "Add new Charity"}
          </DialogTitle>
          <FormControlLabel
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              marginRight: theme.spacing(3)
            }}
            control={
              <Switch
                checked={enabled}
                color="success"
                onChange={event => {
                  setEnabled(event.target.checked);
                }}
              />
            }
            label={enabled ? "Enabled" : "Disabled"}
          />
        </div>
        <DialogContent>
          <Grid container width="30vw" spacing={2}>
            <Grid item xs={6}>
              <TextField
                id="standard-basic"
                label="ID"
                value={charityID}
                onChange={event => {
                  let newText = event.target.value;
                  setCharityID(newText);
                }}
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item xs={6}></Grid>
            <Grid item xs={6}>
              <TextField
                id="standard-basic"
                label="Name"
                value={charityName}
                onChange={event => {
                  let newText = event.target.value;
                  setCharityName(newText);
                }}
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="standard-basic"
                label="LogoURL"
                value={charityLogoURL}
                onChange={event => {
                  let newText = event.target.value;
                  setCharityLogoURL(newText);
                }}
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="standard-basic"
                label="Mission"
                value={charityMission}
                onChange={event => {
                  let newText = event.target.value;
                  setCharityMission(newText);
                }}
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="standard-basic"
                label="Address"
                value={charityAddress}
                onChange={event => {
                  let newText = event.target.value;
                  setCharityAddress(newText);
                  let parsed = addressParse(newText);
                  //console.log(parsed);
                  setCharityAddressParseObj(parsed);
                }}
                variant="outlined"
                fullWidth
              />

              <div style={{ color: "grey" }}>
                <div style={{ margin: "6px 14px" }}>
                  <span style={{ fontStyle: "italic" }}>City:</span>{" "}
                  {charityAddressParseObj && (
                    <span>{charityAddressParseObj.city}</span>
                  )}
                </div>
                <div style={{ margin: "6px 14px" }}>
                  <span style={{ fontStyle: "italic" }}>State/Prov:</span>{" "}
                  {charityAddressParseObj && (
                    <span>{charityAddressParseObj.stateAbbr}</span>
                  )}
                </div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="scope-select-label">Scope</InputLabel>
                <Select
                  labelId="scope-open-select-label"
                  id="scope-open-select"
                  label="Scope"
                  value={charityScope}
                  onChange={async event => {
                    setCharityScope(event.target.value);
                  }}
                >
                  <MenuItem value={SCOPE_MODES.CITY}>City</MenuItem>
                  <MenuItem value={SCOPE_MODES.GLOBAL}>Global</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="standard-basic"
                label="PIN"
                value={charityPin}
                onChange={event => {
                  let newText = event.target.value;
                  setCharityPin(newText);
                }}
                variant="outlined"
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={saveChanges} color="secondary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default CreateCharityDialog;
